import * as Sentry from "@sentry/nextjs";
import { TraceProvider } from "./traceProvider";

export const SentryTraceProvider: TraceProvider = {
  getTraceId: () => {
    const activeSpan = Sentry.getTraceData();
    const traceId = activeSpan?.["sentry-trace"] || null;

    return traceId;
  },

  getSpanId: () => {
    return null;
  },
} as const;
